import { combineReducers } from 'redux';

import pairs from './pairs/reducer';
import tokens from './tokens/reducer';
import limitations from './limitations/reducer';
import fees from './fees/reducer';
import currencies from './currencies/reducer';
import robot from './robot/reducer';

export default combineReducers({
  pairs,
  tokens,
  limitations,
  fees,
  currencies,
  robot,
});
